export default __webpack_public_path__ + "static/media/sybb.3b19d7ac.mp4";